import { BrowserRouter as Router } from "react-router-dom";
import Routing from './routes/Index';
import './assets/vendors/bootstrap/css/bootstrap.min.css';
import './assets/vendors/slick/slick.css';
import './assets/vendors/animation/animate.min.css';
import './assets/vendors/font-awesome/css/all.min.css';
import './assets/vendors/youtube-popup/youtube-popup.css';
import './assets/css/style.css';
import './assets/css/responsive.css';

function App() {
  return (
    <Router basename="/uniqo">
      <Routing />
    </Router>
  )
}

export default App